import { useCallback } from "react";

import toast from "react-hot-toast";

import api from "api";
import util from "utils/utils";

export const useGetCalendarLink = (calendarId: string | undefined) =>
  useCallback(() => {
    if (!calendarId) return;
    api.calendars.getCalendarSyncUrl(
      calendarId,
      ({ syncUrl }) => {
        void util.copyToClipboard(syncUrl);
      },
      (error) => {
        toast.error(error.message);
      },
    );
  }, [calendarId]);
